import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return ($props.rows)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($props.rows, (row, i) => {
            return (_openBlock(), _createBlock($setup["Skeleton"], {
                key: i,
                class: _normalizeClass([
                    row.width && $setup.isTwClass(row.width) ? row.width : (row.width ? undefined : 'w-full'),
                    row.height && $setup.isTwClass(row.height) ? row.height : (row.height ? undefined : 'h-4'),
                ]),
                style: _normalizeStyle({
                    width: row.width && !$setup.isTwClass(row.width) ? row.width : undefined,
                    height: row.height && !$setup.isTwClass(row.height) ? row.height : undefined,
                })
            }, null, 8 /* PROPS */, ["class", "style"]));
        }), 128 /* KEYED_FRAGMENT */))
        : (_openBlock(), _createBlock($setup["Skeleton"], {
            key: 1,
            class: _normalizeClass([$setup.widthClass, $setup.heightClass, $props.circle ? 'rounded-full' : '', $setup.props.class]),
            style: _normalizeStyle({ width: $setup.widthStyle, height: $setup.heightStyle })
        }, null, 8 /* PROPS */, ["class", "style"]));
}
